/** A route node as routesData.js carries it: the full path and its last segment. */
export type RouteNode = { _route: string; _leaf: string };

/** Builds the nodes of the pages under `base`. routesData.js recomputes `_route` from the
 *  `_leaf` chain, and routes.test.ts holds the two equal. */
export const routeUnder =
  (base: string) =>
  (leaf: string): RouteNode => ({ _route: `${base}/${leaf}`, _leaf: leaf });
